// ----------------------------------------------------------------------------
// Geolocation country modal — opens when GeoJS country matches a rule but host differs.
// ----------------------------------------------------------------------------

import 'snippets/_containers/modal/modal';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import './_geolocation-country-modal.scss';
var LOCAL_STORAGE_DISMISS_KEY = 'geolocation-country-modal-dismissed-until';
var DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
var MODAL_ID = 'geolocation-country-modal';
function isDismissedRecently() {
  var raw = localStorage.getItem(LOCAL_STORAGE_DISMISS_KEY);
  if (!raw) {
    return false;
  }
  var until = parseInt(raw, 10);
  return !Number.isNaN(until) && Date.now() < until;
}
function persistDismissForSevenDays() {
  localStorage.setItem(LOCAL_STORAGE_DISMISS_KEY, String(Date.now() + DISMISS_DURATION_MS));
}
function normalizeHost(host) {
  return String(host || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
}
function regionalStoreUrl(host) {
  return "https://".concat(normalizeHost(host)).concat(window.location.pathname).concat(window.location.search).concat(window.location.hash);
}
function fallbackFlagUrl(countryCode) {
  if (!countryCode) {
    return null;
  }
  return "https://flagcdn.com/w40/".concat(String(countryCode).trim().toLowerCase(), ".png");
}
function shouldOpenCountryModal(countryRule) {
  if (!(countryRule !== null && countryRule !== void 0 && countryRule.host)) {
    return false;
  }
  return normalizeHost(countryRule.host) !== window.location.host;
}
function wireRedirectLink(countryRule) {
  var redirectLink = document.getElementById('geolocation-country-modal__redirect');
  if (!redirectLink || !(countryRule !== null && countryRule !== void 0 && countryRule.host)) {
    return;
  }
  var redirectLabel = document.getElementById('geolocation-country-modal__redirect-label');
  var heading = document.getElementById('geolocation-country-modal__heading');
  var redirectFlag = document.getElementById('geolocation-country-modal__redirect-flag-image');
  redirectLink.href = regionalStoreUrl(countryRule.host);
  var storeLabel = String((countryRule === null || countryRule === void 0 ? void 0 : countryRule.demonym) || '').trim() || (countryRule === null || countryRule === void 0 ? void 0 : countryRule.country);
  if (storeLabel && redirectLabel) {
    redirectLabel.textContent = "Proceed to ".concat(storeLabel, " Store");
  }
  if (countryRule !== null && countryRule !== void 0 && countryRule.country && heading) {
    heading.textContent = "Looks like you're located in ".concat(countryRule.country, "?");
  }
  if (redirectFlag) {
    var flagSrc = countryRule.flag || fallbackFlagUrl(countryRule.country_code);
    if (flagSrc) {
      redirectFlag.src = flagSrc;
      redirectFlag.alt = countryRule !== null && countryRule !== void 0 && countryRule.country ? "".concat(countryRule.country, " flag") : '';
    } else {
      redirectFlag.removeAttribute('src');
      redirectFlag.alt = '';
    }
  }
}
function initGeolocationCountryModal() {
  var _window$geo;
  if (!((_window$geo = window.geo) !== null && _window$geo !== void 0 && _window$geo.onLocation)) {
    return;
  }
  var modal = document.getElementById(MODAL_ID);
  if (!modal) {
    return;
  }
  iamotaEventHandler.subscribe("modal:closed:".concat(MODAL_ID), () => {
    persistDismissForSevenDays();
  }, {
    source: 'geolocation-country-modal.js'
  });

  // Persist dismiss when user actively picks a store — these are plain <a> tags
  // so they navigate without firing modal:closed, leaving localStorage unwritten.
  var redirectLink = document.getElementById('geolocation-country-modal__redirect');
  if (redirectLink) {
    redirectLink.addEventListener('click', persistDismissForSevenDays);
  }
  modal.querySelectorAll('.geolocation-country-modal__country-link').forEach(link => {
    link.addEventListener('click', persistDismissForSevenDays);
  });
  window.geo.onLocation(_ref => {
    var error = _ref.error,
      geo = _ref.geo,
      countryRule = _ref.countryRule;
    if (error || !geo) {
      return;
    }
    if (isDismissedRecently()) {
      return;
    }
    if (!shouldOpenCountryModal(countryRule)) {
      return;
    }
    if (!modal.openModal) {
      return;
    }
    wireRedirectLink(countryRule);
    modal.openModal(document.documentElement);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeolocationCountryModal);
} else {
  initGeolocationCountryModal();
}